import { Question } from "types/landlord/verificationTemplate";
import AdditionalInformationIcon from "shared/icons/additionalInformation.svg?react";
import { Section } from "./Section";
import { AdditionalQuestionsAnswers } from "../slices/BasicInformation/AdditionalQuestionsAnswers";

// Same look as the Rental application's Additional Questions section.
export const AdditionalQuestionsReportSection = ({
  answers,
  questions
}: {
  answers?: Record<string, unknown>;
  questions?: Question[];
}) =>
  answers && Object.keys(answers).length > 0 ? (
    <Section
      sectionTitle="Additional Questions"
      icon={<AdditionalInformationIcon />}
    >
      <div className="w-full max-w-[600px]">
        <AdditionalQuestionsAnswers
          answers={answers}
          questions={questions ?? []}
        />
      </div>
    </Section>
  ) : null;
